import React, {useState} from "react";
import { ADMIN_API_BASE } from "../../utils/apiConfig";
import ReCAPTCHA from "react-google-recaptcha";

const AdminLogin = () => {
    const [step, setStep] = useState(1);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [otp, setOtp] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [captchaToken, setCaptchaToken] = useState("");

    const API_BASE = ADMIN_API_BASE;

    const getCsrfToken = async () => {

        const response = await fetch(`${API_BASE}/csrf-token`, {
            method: "GET",
            credentials: "include", // critical to send the session cookie
        });

        const data = await response.json();
        return data.csrfToken;
    };

    const handleLogin = async () => {
        if (!captchaToken) {
            setError("Please complete the reCAPTCHA.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const token = await getCsrfToken();

            const response = await fetch(`${API_BASE}/login/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "csrf-token": token,
                    Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}`,
                },
                body: JSON.stringify({username, password, captchaToken}),
                credentials: "include"
            });

            const data = await response.json();

            if (response.ok) {
                setStep(2);
                setError("");
            } else {
                setError(data.message || "Invalid credentials.");
            }
        } catch (err) {
            console.error("Login error:", err);
            setError("Something went wrong. Please try again." + err);
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async () => {
        if (!otp) {
            setError("Please enter the OTP.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const token = await getCsrfToken();

            const response = await fetch(`${API_BASE}/verify-otp/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "csrf-token": token,
                    Authorization: `Bearer ${process.env.REACT_APP_ADMIN_TOKEN}`,
                },
                body: JSON.stringify({otp}),
                credentials: "include",
            });

            const data = await response.json();

            if (response.ok && data.success) {
                window.location.href = data.redirect;
            } else {
                setError(data.message || "Invalid OTP.");
            }
        } catch (err) {
            console.error("OTP error:", err);
            setError("Verification failed. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex w-full h-screen justify-center items-center ltr bg-gray-100">
            <div className="flex flex-col w-1/3 p-10 bg-white border-2 border-gray-300 shadow-lg rounded-xl">
                <h2 className="text-xl font-bold text-center mb-8">
                    {step === 1 ? "Admin Login" : "Enter OTP"}
                </h2>

                {error && <p className="text-red-500 text-md mb-2 text-center">{error}</p>}

                {step === 1 ? (
                    <>
                        <input
                            type="text"
                            placeholder="Username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="p-3 w-full bg-gray-50 border mb-6 rounded-md"
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="p-3 w-full bg-gray-50 border mb-6 rounded-md"
                        />

                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                            onChange={(token) => setCaptchaToken(token)}
                        />

                        <button
                            onClick={handleLogin}
                            disabled={loading}
                            className={`w-full p-3 mt-5 text-white rounded-md ${
                                loading ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        >
                            {loading ? "Logging in..." : "Login"}
                        </button>
                    </>
                ) : (
                    <>
                        <input
                            type="text"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            className="p-2 w-full bg-gray-50 border mb-2 rounded"
                        />
                        <button
                            onClick={handleOtpSubmit}
                            disabled={loading}
                            className={`w-full p-3 text-white rounded ${
                                loading ? "bg-gray-400 cursor-not-allowed" : "bg-green-500 hover:bg-green-600"
                            }`}
                        >
                            {loading ? "Verifying..." : "Verify OTP"}
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default AdminLogin;
